<div class="row">
    <div class="col-sm-12" style="display: flex; justify-content: space-between;">
        <h3 class="col-sm-5"> Validation du {{this.bp.code}} {{this.bp.societe ? '('+ this.bp.societe.code + ')' :''}} </h3>
        <div class="col-sm-7" style="justify-content: space-between;">
            <button color="default" mat-raised-button type="button" (click)="close()">
                <mat-icon>arrow_back</mat-icon>Retour à la liste
            </button>
            <app-pdf-bp [bp]="bp"></app-pdf-bp>
            <button color="warn" *ngIf="!this.bp.bBloque" mat-raised-button type="button" (click)="bloquer()">
                <mat-icon>lock</mat-icon>Bloquer
            </button>

            <button color="success" *ngIf="this.bp.bBloque" mat-raised-button type="button" (click)="debloquer()">
                <mat-icon>lock_open</mat-icon>Débloquer
            </button>

            <button color="success" *ngIf="!this.bp.bBloque" mat-raised-button type="button" (click)="validate()">
                <mat-icon>check</mat-icon>Valider
            </button>
            <button color="danger" *ngIf="!this.bp.bBloque" mat-raised-button type="button" (click)="refus()">
                <mat-icon>not_interested</mat-icon>Retour pour complément
            </button>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-sm-10 padding-0"  id="validate-bp-container">
        <app-bp-form [form]="bpForm" [detailInfo]="detailBpInfo" [amountHT]="bpLineHTs" [amountTTC]="bpLineTTCs"
            [amountTVA]="bpLineTVAs"></app-bp-form>
            <br>
    </div>

    <div [ngClass]="parentWidth < 576 ? 'padding-0 mb-4' : 'col-sm-2 padding-0'">
        <app-cycles-bp [cycles]="bp.cycleBps" [title]="bp.code"></app-cycles-bp>
    </div>

    <mat-card [ngClass]="childHeight < 285 ? 'col-sm-12' : 'col-sm-10'">
        <mat-card-content>
            <app-fixed-bp-line-list-validation 
                class="row" 
                [form]="bpForm"
            >
            </app-fixed-bp-line-list-validation>
        </mat-card-content>
    </mat-card>
    
</div>